import { useMutation } from "react-query";
import { addLeasedEquipmentSupplyAlertProfile } from "../../../../../actions/Utilities/LeasedEquipmentSupplyAlertProfile";
import { toast } from "components/toastNotification";
import { ISupplyAlertProfile } from "../types";

const useAddSupplyAlertProfile = () => {
    const { mutate } = useMutation(
        (NewData: ISupplyAlertProfile) => addLeasedEquipmentSupplyAlertProfile(NewData),
        {
            onSuccess: (res: any) => {
                switch (true) {
                    case res == "Success":
                        toast.fire("Success", "Supply Alert Profile Added Successfully", "success");
                        break;
                    case res.includes("Notification insert Failed"):
                        toast.fire(
                            "Success ",
                            `Supply Alert Profile Added Successfully, BUT ${res}`,
                            "warning"
                        );
                        break;
                    case res == "Operation Failed!":
                        toast.fire("Adding Supply Alert Profile failed ", `Server Error: ${res}`, "error");
                        break;
                    case res == "The data already exists!":
                        toast.fire(
                            "Adding Supply Alert Profile failed",
                            `Duplication Error: ${res}`,
                            "error"
                        );
                        break;
                    case res.includes("Action object"):
                        toast.fire("Adding Supply Alert Profile failed ", `Error: ${res}`, "error");
                        break;
                    default:
                        toast.fire("Adding Supply Alert Profile failed", res.Message, "error");
                }
            },

            onError: (error: any) => {
                toast.fire("Add Supply Alert Profile failed", `Error: ${error}`, "error");
            },
        }
    );

    return mutate;
};
export default useAddSupplyAlertProfile;
